import type { Category } from '@/types/content';

export const categories: Category[] = [
  {
    key: 'figure',
    name: '人物档案',
    desc: '按人物归档，梳理公开行程、作品与合作关系，形成可追溯的条目。',
    icon: 'ri-user-search-line',
    count: 128,
  },
  {
    key: 'review',
    name: '事件复盘',
    desc: '把通告单、流程单与场记单拼回原样，重新走一遍事件发生那几天。',
    icon: 'ri-history-line',
    count: 96,
  },
  {
    key: 'context',
    name: '秘史脉络',
    desc: '跳出单点事件，对照更长周期，看清一段关系或一家机构的起伏曲线。',
    icon: 'ri-node-tree',
    count: 74,
  },
  {
    key: 'timeline',
    name: '时间线整理',
    desc: '以日期为轴，把散落的信息按时间摆开，让空白期不再完全空白。',
    icon: 'ri-timeline-view',
    count: 63,
  },
  {
    key: 'verify',
    name: '资料考据',
    desc: '对笔迹、批注、版本差异做比对，只保留能够被公开核对的条目。',
    icon: 'ri-file-search-line',
    count: 58,
  },
  {
    key: 'retrospect',
    name: '旧事重提',
    desc: '旧闻不必旧说，用新出现的旁证回头核对当年的通讯稿与报道。',
    icon: 'ri-archive-2-line',
    count: 81,
  },
];